import React, { forwardRef, RefObject } from 'react';

import { BarChartProps } from './types';
import { StyledBarChart } from './styles';

export const LoadingBarChart = forwardRef<HTMLDivElement, BarChartProps>(
  (props, ref) => {
    const { className, ...forwardedProps } = props;

    return (
      <StyledBarChart
        {...forwardedProps}
        className={className}
        ref={ref as RefObject<HTMLDivElement>}
      >
        Loading...
      </StyledBarChart>
    );
  }
);
